export * from './informantPanel.component';
